import React, { useContext, useEffect } from "react";
import { Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { context } from "./../../context/context";
import config from "../../services/config.json";

const DiscountUploadMedia = () => {
  // context
  const {
    discountMedia,
    setDiscountMedia,
    discountCover,
    setDiscountCover,
    discountMediaId,
    
    discountCoverId,
    
    setDiscountCoverId,
    setDiscountMediaId
  } = useContext(context);

  //useEffect
  useEffect(() => {
    setDiscountCoverId(discountCover[0] ? discountCover[0]._id : null);
    const ids = [];
    const files = [];
    discountMedia.map((file) => {
      ids.push(file._id);
      files.push({
        uid: file._id,
        name: file._id,
        status: "done",
        url: file.address,
      });
    });
    setDiscountMediaId(ids);
    setDiscountMedia(files);
    setDiscountCover([
      {
        uid: discountCoverId,
        name: "image.png",
        status: "done",
        url: discountCover[0]?.address,
      },
    ]);
  }, []);
  // upload
  const onChangeCover = (info) => {
    setDiscountCover(info.fileList);
    if (info.file.status === "done") {
      message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
      setDiscountCoverId(info.file.response.files[0]._id);
    } else if (info.file.status === "error") {
      message.error(` در آپلود فایل خطایی رخ داد!`);
    }
  };
  const onChange = (info) => {
    setDiscountMedia(info.fileList);
    if (info.file.status === "done") {
      message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
      info.file.response.files.map((file) => {
        setDiscountMediaId([...discountMediaId, file._id]);
      });
    } else if (info.file.status === "error") {
      message.error(` در آپلود فایل خطایی رخ داد!`);
    }
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  const handleRemove = (info) => {
    const newFiles = discountMedia.filter((file) => file !== info);
    const newIds = discountMediaId.filter((id) => id !== info.uid);
    setDiscountMediaId(newIds);
    setDiscountMedia(newFiles);
  };
  

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "2rem 0",
        gap: "2rem",
      }}
    >
      <ImgCrop rotationSlider>
        <Upload
          maxCount={1}
          multiple={false}
          name="objectKey"
          action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65ead6e0a3b46a402ebc7993`}
          listType="picture-card"
          fileList={discountCover}
          onChange={onChangeCover}
          onPreview={onPreview}
        >
          {discountCover.length < 3 && "+ آپلود عکس کاور"}
        </Upload>
      </ImgCrop>
      <ImgCrop rotationSlider>
        <Upload
          accept="image/*"
          multiple={false}
          name="objectKey"
          action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65ead6e0a3b46a402ebc7993`}
          listType="picture-card"
          fileList={discountMedia}
          onChange={onChange}
          onPreview={onPreview}
          onRemove={handleRemove}
        >
          {discountCover.length < 10 && "+ آپلود عکس"}
        </Upload>
      </ImgCrop>
      <Upload
        accept="video/*"
        multiple={false}
        name="objectKey"
        action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65ead6e0a3b46a402ebc7993`}
        listType="picture-card"
        fileList={discountMedia}
        onChange={onChange}
        onPreview={onPreview}
        onRemove={handleRemove}
      >
        {discountCover.length < 10 && "+ آپلود ویدیو"}
      </Upload>
    </div>
  );
};

export default DiscountUploadMedia;
